export default "__VITE_ASSET__CtCBvR5v__"